import { get } from '../../../../Utils/fetch';

interface MembershipPlan {
  id: string;
  shopId: string;
  type: string;
  name: {
    en: string;
    da: string;
    sv: string;
  };
  description: {
    en: string;
    da: string;
    sv: string;
  };
  prices: {
    monthly: number | null;
    annual: number | null;
  };
  perks: {
    vouchers: {
      type: string;
      value: number;
      days: {
        weekday: string;
        valid: boolean;
      }[];
    }[];
  };
}

export const loadMembershipPlan = async (planId: string) => {
  console.log('loadMembershipPlan', planId);
  const plan: MembershipPlan | undefined = await get(`Plans/${planId}`);
  return plan;
};
